import { create } from 'zustand';

import type { LiveAlarmEvent } from '../types/alarm';

const MAX_EVENTS = 1000;

interface AlarmEventStore {
  events: LiveAlarmEvent[];
  addEvent: (event: LiveAlarmEvent) => void;
  clearEvents: () => void;
  getByCamera: (cameraId: string) => LiveAlarmEvent[];
  getRecentCount: (cameraId: string, windowMs?: number) => number;
}

export const useAlarmEventStore = create<AlarmEventStore>((set, get) => ({
  events: [],
  addEvent: event =>
    set(state => ({
      events: [event, ...state.events].slice(0, MAX_EVENTS),
    })),
  clearEvents: () => set({ events: [] }),
  getByCamera: cameraId => get().events.filter(e => e.camera_id === cameraId),
  getRecentCount: (cameraId, windowMs = 300_000) => {
    const cutoff = Date.now() - windowMs;
    return get().events.filter(
      e => e.camera_id === cameraId && e.arrived_at > cutoff
    ).length;
  },
}));
